var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "main",
    { staticClass: "kvizove-ulohy" },
    [
      _c(
        "article",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.step === "uvod",
              expression: "step === 'uvod'"
            }
          ],
          staticClass: "d-grid position-relative uvod-height"
        },
        [
          _vm.skolskaUloha
            ? [
                _vm.skolskaUloha.pozadie
                  ? _c("img", {
                      staticClass: "uvodny-obr",
                      attrs: {
                        src: _vm.skolyStorage + _vm.skolskaUloha.pozadie,
                        alt: ""
                      }
                    })
                  : _c("img", {
                      staticClass: "uvodny-obr",
                      attrs: { src: "assets/img/uvod-kviz.jpg", alt: "" }
                    }),
                _vm._v(" "),
                _c("div", { staticClass: "position-absolute" }, [
                  _c("span", { staticClass: "badge-pill --success mb-30" }, [
                    _vm._v(_vm._s(_vm.skolskaUloha.nazov))
                  ]),
                  _vm._v(" "),
                  _c("h2", { staticClass: "mb-30" }, [
                    _vm._v(_vm._s(_vm.skolskaUloha.podnadpis))
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "mb-50" }, [
                    _vm._v(_vm._s(_vm.skolskaUloha.zadanie))
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn --primary btn-lg",
                      on: {
                        click: function($event) {
                          _vm.step = "nahravanie"
                        }
                      }
                    },
                    [
                      _vm._v("Nahrať kresby"),
                      _c("span", { staticClass: "icon --arrow-right" })
                    ]
                  )
                ])
              ]
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "article",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.step === "nahravanie",
              expression: "step === 'nahravanie'"
            }
          ],
          staticClass: "screen-w-controls"
        },
        [
          _c(
            "div",
            { staticClass: "top-info" },
            [
              _c("p", [
                _vm.skolskaUloha
                  ? _c("b", [_vm._v(_vm._s(_vm.skolskaUloha.podnadpis))])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _vm._m(0),
              _vm._v(" "),
              _c("b-tooltip", {
                attrs: {
                  target: "tooltip-target-1",
                  variant: "danger",
                  "custom-class": "dark-tooltip",
                  triggers: "hover"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "vue-dropzone",
            {
              ref: "submissionDropzone",
              attrs: {
                id: "submissionDropzone",
                options: _vm.dropzoneOptions,
                duplicateCheck: true,
                useCustomSlot: true
              },
              on: {
                "vdropzone-success": _vm.fileUploaded,
                "vdropzone-sending": _vm.addAdditionalParams,
                "vdropzone-error": _vm.fileUploadError,
                "vdropzone-removed-file": _vm.fileRemoved
              }
            },
            [
              _c("div", { staticClass: "dropzone-custom-content" }, [
                _c("img", {
                  staticClass: "img-fluid",
                  attrs: { src: "assets/img/upload-img.svg", alt: "" }
                }),
                _vm._v(" "),
                _c("h3", { staticClass: "dropzone-custom-title" }, [
                  _vm._v("Preneste sem fotografie myškou,")
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "mb-0" }, [
                  _vm._v(
                    "alebo kliknite na tlačítko + nižsie na nahrajte fotografie ručne."
                  )
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c("b-error", { attrs: { alert: _vm.error } }),
          _vm._v(" "),
          _c("div", { staticClass: "controls" }, [
            _c(
              "button",
              {
                staticClass: "btn --primary",
                on: {
                  click: function($event) {
                    return _vm.$refs.submissionDropzone.$el.click()
                  }
                }
              },
              [_c("span", { staticClass: "icon --plus" })]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn --primary",
                attrs: { disabled: _vm.saving },
                on: { click: _vm.saveVypracovanie }
              },
              [
                _vm._v("Odoslať súbory"),
                _c("span", { staticClass: "icon --arrow-right ml-10" })
              ]
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "article",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.step === "vyhodnotenie",
              expression: "step === 'vyhodnotenie'"
            }
          ],
          staticClass: "d-grid position-relative bg-white full-h"
        },
        [
          _c("img", {
            staticClass: "img-fluid",
            attrs: { src: "assets/img/vyhodnotenie-bg.jpg", alt: "" }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "position-absolute" },
            [
              _c("img", {
                staticClass: "img-fluid mb-20",
                attrs: { src: "assets/img/success-badge.svg", alt: "" }
              }),
              _vm._v(" "),
              _c("h2", { staticClass: "mb-10" }, [
                _vm._v("Výborne, zvládli ste to!")
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "mb-30" }, [
                _vm._v("Kravička je na vás pyšná.")
              ]),
              _vm._v(" "),
              _vm.skolskaUloha && _vm.skolskaUloha.is_individualna
                ? _c("p", { staticClass: "text-success text-48" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.vypracovanie.subory.length <=
                            _vm.profil.pouzivatel_id.pouzivatel_pocet_ziakov
                            ? _vm.vypracovanie.subory.length
                            : _vm.profil.pouzivatel_id.pouzivatel_pocet_ziakov
                        ) +
                        " / " +
                        _vm._s(
                          _vm.profil.pouzivatel_id.pouzivatel_pocet_ziakov
                        ) +
                        "\n            "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.profil.pouzivatel_id
                ? _c(
                    "router-link",
                    {
                      staticClass: "btn --primary",
                      attrs: {
                        to: {
                          name: "skoly-ulohy",
                          params: {
                            rocnik: _vm.profil.pouzivatel_id.pouzivatel_rocnik
                          }
                        }
                      }
                    },
                    [
                      _vm._v("\n                spať na zoznam úloh"),
                      _c("span", { staticClass: "icon --bars" })
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _vm.profil.pouzivatel_id
        ? _c(
            "router-link",
            {
              staticClass: "btn --secondary --circle close-btn",
              attrs: {
                to: {
                  name: "skoly-ulohy",
                  params: { rocnik: _vm.profil.pouzivatel_id.pouzivatel_rocnik }
                }
              }
            },
            [_c("span", { staticClass: "icon --close" })]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { attrs: { id: "tooltip-target-1" } }, [
      _c("span", { staticClass: "icon --info-circle color-icon mr-10" }),
      _vm._v(
        "Kreatívnu úlohu vypracúva každý z triedy za seba, alebo celý kolektív spolu."
      ),
      _c("br"),
      _vm._v(
        " 100% bodov získava trieda v momente, keď každý za seba vypracoval úlohu podľa zadania a pani učiteľka/pán učiteľ nahrali všetky fotografie."
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }